// config.js

const bizIcon = "https://pavel-kopets.vercel.app/pavel-kopets-icon.webp";
const imageOne = "https://images.pexels.com/photos/1642125/pexels-photo-1642125.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1";
const imageTwo = "https://images.pexels.com/photos/1080696/pexels-photo-1080696.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1";
const imageThree = "https://images.pexels.com/photos/1481105/pexels-photo-1481105.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1";
const imageFour = "https://images.pexels.com/photos/210617/pexels-photo-210617.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1";
const imageFive = "https://images.pexels.com/photos/87223/pexels-photo-87223.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1";

const socialMediaLink = "https://www.urbanrealtygroupre.com/";

export const siteConfig = {
  title: "Pavel Kopets",
  metaDescription: "Pavel Kopets | Keller Williams",
  theme: {
    primaryColor: "blue-600",
    secondaryColor: "gray-900",
    accentColor: "text-blue-500"
  },
  logo: {
    src: bizIcon,
    alt: "Pavel Kopets | Keller Williams",
  },
  navigation: [
    { name: "Services", sectionId: "services" },
    { name: "About", sectionId: "about" },
    { name: "Location", sectionId: "location" },
  ],
  businessDetails: {
    name: "Pavel Kopets | Keller Williams",
    headline: "Trusted Remodeling and Renovation Experts in Boise",
    address: "1065 South Allante Place, Boise, ID 83709, USA",
    description: "Pavel Kopets | Keller Williams offers expert guidance in real estate to help you find the perfect home or investment. From navigating local markets to handling every detail of the buying and selling process, Pavel is here to elevate your real estate experience.",
  },
  images: {
    business: {
      src: imageOne,
      alt: "Your Trusted Real Estate Expert in Massachusetts",
      width: 2432,
      height: 1442
    }
  },
  features: [
    {
      name: 'Local Market Expertise',
      description: 'Pavel brings in-depth knowledge of local communities, market conditions, and property values to help you make informed real estate decisions.',
    },
    {
      name: 'Personalized Service',
      description: 'From finding the right home to matching your lifestyle needs, Pavel ensures a tailored experience that meets your expectations.',
    },
    {
      name: 'Comprehensive Selling Support',
      description: 'Pavel handles everything from marketing your home and negotiating offers to managing paperwork and closing, making the selling process smooth and efficient.',
    }
  ],
  services: {
    sectionTitle: "Featured Properties",
    description: "Pavel Kopets is dedicated to helping clients find the perfect property in Boise and surrounding areas. Whether you’re looking for a single-family home, a condo, or land to build on, Pavel’s local expertise and commitment to client satisfaction ensure a smooth and successful real estate experience.",
    callouts: [
      {
        name: 'Single Family Homes',
        description: 'Ideal for families and individuals looking for a private residence with space and amenities.',
        details: 'Explore beautiful single-family homes in neighborhoods with great schools, parks, and a strong sense of community. Pavel’s in-depth local knowledge ensures you’ll find a home that meets all your needs.',
        imageSrc: imageTwo,
        imageAlt: 'Charming single-family home in Boise',
      },
      {
        name: 'Condos, Townhouses & Co-ops',
        description: 'Perfect for those seeking a low-maintenance lifestyle with modern conveniences.',
        details: 'Pavel helps clients navigate a variety of condo and townhouse options, from sleek urban spaces to cozy suburban settings, matching each property to your lifestyle and preferences.',
        imageSrc: imageThree,
        imageAlt: 'Modern condo in a vibrant Boise neighborhood',
      },
      {
        name: 'Lots, Land & Acreage',
        description: 'Ideal for investors or buyers looking to build a custom home.',
        details: 'For clients interested in land or acreage, Pavel provides guidance on potential investments, zoning, and market opportunities to ensure you make the best possible decision.',
        imageSrc: imageFour,
        imageAlt: 'Expansive land for development near Boise',
      }
    ]
  },
  about: {
    sectionTitle: "About Pavel Kopets",
    description: "In today's competitive real estate market, you need a dedicated local expert to guide you through every step of buying or selling a home. Pavel Kopets brings extensive knowledge of Boise’s communities, current market trends, and the real estate process. He is committed to delivering a seamless experience and ensuring his clients make the best possible decisions.",
    image: {
      src: imageFive,
      alt: "Pavel Kopets, real estate agent",
      width: 1200,
      height: 800
    }
  },
  location: {
    sectionTitle: "Our Location",
    destinationAddress: "1065 South Allante Place, Boise, ID 83709, USA",
    googleMapsEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3068.578797021715!2d-116.25983698424958!3d43.578179579123176!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54aefc6d0b2a9ad1%3A0x36c4f688a9bb7e88!2s1065%20S%20Allante%20Pl%2C%20Boise%2C%20ID%2083709%2C%20USA!5e0!3m2!1sen!2sus!4v1710407450828!5m2!1sen!2sus",
    subCategories: [
      { name: 'Apple Maps', url: 'https://maps.apple.com/?address=1065%20South%20Allante%20Place,%20Boise,%20ID%2083709&ll=43.5782,-116.2598&q=1065%20South%20Allante%20Place' },
      { name: 'Bing Maps', url: 'https://www.bing.com/maps?q=1065+South+Allante+Place,+Boise,+ID+83709&FORM=HDRSC6' },
      { name: 'Google Earth', url: 'https://earth.google.com/web/search/1065+South+Allante+Place,+Boise,+ID+83709,+USA/@43.5782,-116.2598,15a,814.57589625d,35y,0h,0t,0r' },
      { name: 'Google Maps', url: 'https://goo.gl/maps/36c4f688a9bb7e88' }
    ]
  },
  contact: {
    sectionTitle: "Ready to Find Your Dream Home?",
    description: "Contact Pavel Kopets to discuss your real estate needs or to schedule a consultation. Whether you're buying, selling, or investing, Pavel is here to provide expert guidance every step of the way.",
    manager: {
      name: "Pavel Kopets",
      title: "Real Estate Agent",
      email: "kopetspav@gmail.com",
    },
    socialLinks: {
      facebook: socialMediaLink,     
      instagram: socialMediaLink,
      twitter: socialMediaLink,
      linkedin: socialMediaLink,
      youtube: socialMediaLink
    },
    contactNumbers: [
      "Office: +1 (208) 284-2213"
    ],
    logo: bizIcon,
    emailRecipient: "WebDev@bizsolutions.us"
  },
  footer: {
    bizSolutionsLogo: "https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg"
  }
};
